/**
 * Project API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeliveryCategoryModel } from './deliveryCategory';
import { ProjectStatusModel } from './projectStatus';
import { BudgetTypeModel } from './budgetType';
import { ProjectInvoiceScheduleModel } from './projectInvoiceSchedule';
import { AiTermsModel } from './aiTerms';
import { EffectiveAiTermsModel } from './effectiveAiTerms';
import { ProjectOrderReserveModel } from './projectOrderReserve';
import { InvoicingTypeModel } from './invoicingType';
import { ProjectTypeModel } from './projectType';


export interface ProjectOutputModel { 
    /**
     * Project ID
     */
    id: string;
    /**
     * Collated Customer & Project names for display purposes
     */
    projectNameWithCustomerNamePrefix?: string;
    /**
     * Resourcing restrictions from the customer record
     */
    customerResourcingRestrictions?: ProjectOutputModel.CustomerResourcingRestrictionsEnum;
    customerAiTerms?: AiTermsModel;
    effectiveAiTerms?: EffectiveAiTermsModel;
    budgetType?: BudgetTypeModel;
    deliveryCategory?: DeliveryCategoryModel;
    invoicingType?: InvoicingTypeModel;
    type?: ProjectTypeModel;
    status?: ProjectStatusModel;
    from?: string;
    to?: string;
    csatLastSent?: string;
    /**
     * Currency for project\'s financials
     */
    currency?: string;
    /**
     * Email address to which CSATs should be sent
     */
    csatRecipientEmail?: string;
    /**
     * Employee to whom internal CSATs should be sent
     */
    csatInternalRecipientAuthId?: string;
    /**
     * ID of applied project category
     */
    categoryId?: string;
    /**
     * ID of the business unit/cost center owning the project
     */
    costCenterId?: string;
    /**
     * ID of the customer record
     */
    customerId?: string;
    createdByTenantId?: string;
    /**
     * Description of the project
     */
    description?: string;
    /**
     * Project name
     */
    projectName?: string;
    /**
     * ID of the project/engagement manager
     */
    projectManagerAuthId?: string;
    /**
     * ID of the sales manager
     */
    salesManagerAuthId?: string;
    /**
     * ID of the account manager
     */
    accountManagerAuthId?: string;
    /**
     * ID of the delivery manager
     */
    deliveryManagerAuthId?: string;
    /**
     * Order reserve
     */
    orderReserve?: number;
    orderReserves?: Array<ProjectOrderReserveModel>;
    /**
     * Complexity of the project (for GM)
     */
    complexity?: number;
    /**
     * Is this an AMS (Baseline) project?
     */
    ams?: boolean;
    /**
     * Is this an AMS Scalable project?
     */
    amsScalable?: boolean;
    /**
     * Are there on-calls on the project?
     */
    onCall?: boolean;
    /**
     * Should hours logged on the project be non-productive?
     */
    excludeFromUtilization?: boolean;
    /**
     * Requires revenue accruals in the financial systems
     */
    accrualsNeeded?: boolean;
    /**
     * Does the project require an NDA?
     */
    ndaProject?: boolean;
    /**
     * Does the project use Smart Resourcing?
     */
    smartResourcing?: boolean;
    /**
     * Is there CSAT on the project?
     */
    csatEnabled?: boolean;
    /**
     * Exclude this project from Timesheet Health Score calculations?
     */
    excludeFromThs?: boolean;
    aiTerms?: AiTermsModel;
    /**
     * Is the project SPM managed?
     */
    isITBMProject?: boolean;
    tasksIds?: Array<string>;
    invoiceSchedules?: Array<ProjectInvoiceScheduleModel>;
    nextPriceAdjustment?: string;
    parentProjectId?: string;
    /**
     * ID of the offering which the project belongs to
     */
    offeringId?: string;
}
export namespace ProjectOutputModel {
    export type CustomerResourcingRestrictionsEnum = 'NONE' | 'EU_ONLY' | 'UNKNOWN';
    export const CustomerResourcingRestrictionsEnum = {
        None: 'NONE' as CustomerResourcingRestrictionsEnum,
        EuOnly: 'EU_ONLY' as CustomerResourcingRestrictionsEnum,
        Unknown: 'UNKNOWN' as CustomerResourcingRestrictionsEnum
    };
}


